import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import axios from "axios";
import { IBookingNote, ReactQueryKey } from "../../types";

export const getBookingNotes = async (bookingId: string): Promise<IBookingNote[]> => {
    const response = await axios.get(`/booking/${bookingId}/notes`);
    return response.data;
};

export const useBookingNotesQuery = (bookingId?: string, options?: UseQueryOptions<IBookingNote[] | null>) => {
    return useQuery<IBookingNote[] | null>(
        [ReactQueryKey.BookingNotes, bookingId],
        () => {
            if (bookingId) {
                return getBookingNotes(bookingId);
            }
            return null;
        },
        options
    )
};